import { isRouteErrorResponse, useRouteError } from "react-router-dom"

import { ErrorPage } from "../error-page";

export const RouteError = () => {
    const error = useRouteError();

    if (isRouteErrorResponse(error)) {
        const message = 'Щось пішло не так...';
        return <ErrorPage message={message}/>;
    }
    
    throw error;
}